import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Modal.scss';

// Koľko modálov je práve otvorených. Modály sa vnorujú (napr. hlásenie chyby
// nad otvoreným OrderModalom) a bez počítadla by zatvorenie toho vrchného
// vrátilo scrollovanie `body` aj tomu spodnému, ktorý ostáva otvorený.
let otvorenychModalov = 0;

function Modal({ isOpen, onClose, title, children, footer, className = '', size = 'default' }) {
  const mouseDownOnOverlay = useRef(false);
  // Close on Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  // Prevent body scroll
  useEffect(() => {
    if (!isOpen) return undefined;
    otvorenychModalov += 1;
    document.body.style.overflow = 'hidden';
    return () => {
      otvorenychModalov -= 1;
      if (otvorenychModalov <= 0) {
        otvorenychModalov = 0;
        document.body.style.overflow = '';
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClass = `modal--${size}`;

  return createPortal(
    <div
      className={`modal__overlay ${className}`}
      onMouseDown={(e) => { mouseDownOnOverlay.current = e.target === e.currentTarget; }}
      onMouseUp={(e) => { if (mouseDownOnOverlay.current && e.target === e.currentTarget) onClose?.(); mouseDownOnOverlay.current = false; }}
    >
      <div className={`modal__content ${sizeClass}`}>
        {title && (
          <div className="modal__header">
            <h2 className="modal__title">{title}</h2>
            <button className="modal__close" onClick={onClose} aria-label="Close">
              &times;
            </button>
          </div>
        )}
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}

export default Modal;
